/**
 * AUTO-GENERATED by `pnpm run capabilities-gen:ot` from frontend/capabilities.csv.
 * DO NOT EDIT — edit the CSV and regenerate. 38 OT capabilities.
 */
export type ReqType = 'any' | 'staff' | 'client' | 'anon';
export type ReqRole = 'company_admin' | 'teamlead' | 'office_manager' | 'agent';
export type ReqCode =
  | 'deal_management'
  | 'user_management'
  | 'user_documents'
  | 'application_processing'
  | 'payload'
  | 'connect_manager'
  | 'media_center'
  | 'marketing_manager';

export interface CapabilityRule {
  readonly name: string;
  readonly reqType: readonly ReqType[];
  readonly reqRole: readonly ReqRole[];
  readonly reqCode: ReqCode | null;
}

export const CAPABILITY_RULES = [
  {
    name: 'canManageDeal',
    reqType: ['staff'],
    reqRole: ['company_admin', 'teamlead', 'agent', 'office_manager'],
    reqCode: 'deal_management',
  },
  {
    name: 'canManageDealComposition',
    reqType: ['staff'],
    reqRole: ['company_admin', 'teamlead', 'agent', 'office_manager'],
    reqCode: 'deal_management',
  },
  {
    name: 'canEditDealInvoice',
    reqType: ['staff'],
    reqRole: ['company_admin', 'teamlead', 'office_manager'],
    reqCode: 'deal_management',
  },
  {
    name: 'canModerateAgentNotes',
    reqType: ['staff'],
    reqRole: ['company_admin', 'teamlead', 'office_manager'],
    reqCode: 'deal_management',
  },
  {
    name: 'canManageDealTasks',
    reqType: ['staff'],
    reqRole: ['company_admin', 'teamlead', 'agent', 'office_manager'],
    reqCode: 'deal_management',
  },
  {
    name: 'canCreateRequiredTask',
    reqType: ['staff'],
    reqRole: ['company_admin', 'teamlead', 'office_manager'],
    reqCode: 'deal_management',
  },
  {
    name: 'canExemptApprovedDealTask',
    reqType: ['staff'],
    reqRole: ['teamlead', 'office_manager'],
    reqCode: 'deal_management',
  },
  {
    name: 'canSubmitDealForApproval',
    reqType: ['staff'],
    reqRole: ['company_admin', 'teamlead', 'agent', 'office_manager'],
    reqCode: 'deal_management',
  },
  {
    name: 'canApproveDeal',
    reqType: ['staff'],
    reqRole: ['company_admin', 'teamlead', 'office_manager'],
    reqCode: 'application_processing',
  },
  {
    name: 'canRejectDeal',
    reqType: ['staff'],
    reqRole: ['company_admin', 'teamlead', 'office_manager'],
    reqCode: 'deal_management',
  },
  {
    name: 'canViewDealApprovalsQueue',
    reqType: ['staff'],
    reqRole: ['company_admin', 'teamlead', 'office_manager'],
    reqCode: 'deal_management',
  },
  {
    name: 'canViewWorkQueueData',
    reqType: ['staff'],
    reqRole: ['company_admin', 'teamlead', 'agent', 'office_manager'],
    reqCode: 'deal_management',
  },
  {
    name: 'canViewDealAccounting',
    reqType: ['staff'],
    reqRole: ['company_admin'],
    reqCode: 'deal_management',
  },
  {
    name: 'canManageAgentCommissionPayments',
    reqType: ['staff'],
    reqRole: ['company_admin', 'teamlead', 'agent', 'office_manager'],
    reqCode: 'deal_management',
  },
  {
    name: 'canManagePayload',
    reqType: ['staff'],
    reqRole: ['company_admin'],
    reqCode: 'payload',
  },
  {
    name: 'canFilterDealsByTeam',
    reqType: ['staff'],
    reqRole: ['company_admin', 'teamlead', 'office_manager'],
    reqCode: null,
  },
  {
    name: 'canFilterDealsByAgent',
    reqType: ['staff'],
    reqRole: ['company_admin', 'teamlead', 'office_manager'],
    reqCode: null,
  },
  {
    name: 'canFilterDealsByOffice',
    reqType: ['staff'],
    reqRole: ['company_admin', 'office_manager'],
    reqCode: null,
  },
  {
    name: 'canFilterDealsByState',
    reqType: ['staff'],
    reqRole: ['office_manager'],
    reqCode: null,
  },
  {
    name: 'canViewWorkQueueDashboard',
    reqType: ['staff'],
    reqRole: ['company_admin', 'teamlead', 'office_manager'],
    reqCode: 'deal_management',
  },
  {
    name: 'canManageRentalApplications',
    reqType: ['staff'],
    reqRole: ['company_admin', 'teamlead', 'office_manager'],
    reqCode: 'application_processing',
  },
  {
    name: 'canDownloadApplicationDocuments',
    reqType: ['staff'],
    reqRole: ['company_admin', 'teamlead', 'office_manager'],
    reqCode: 'application_processing',
  },
  {
    name: 'canViewApplicationProofOfIncome',
    reqType: ['staff'],
    reqRole: ['company_admin', 'teamlead', 'office_manager'],
    reqCode: 'application_processing',
  },
  {
    name: 'canManageTenantReport',
    reqType: ['staff'],
    reqRole: ['company_admin', 'teamlead', 'office_manager'],
    reqCode: 'application_processing',
  },
  {
    name: 'canViewApplicationTenantReport',
    reqType: ['staff'],
    reqRole: ['company_admin', 'teamlead', 'agent', 'office_manager'],
    reqCode: 'application_processing',
  },
  {
    name: 'canManageAnnualGoals',
    reqType: ['staff'],
    reqRole: ['company_admin', 'teamlead', 'agent', 'office_manager'],
    reqCode: 'deal_management',
  },
  {
    name: 'canManageListing',
    reqType: ['staff'],
    reqRole: ['agent', 'company_admin', 'teamlead', 'office_manager'],
    reqCode: null,
  },
  {
    name: 'canViewProductionDetailReport',
    reqType: ['staff'],
    reqRole: ['company_admin', 'teamlead', 'agent', 'office_manager'],
    reqCode: 'deal_management',
  },
  {
    name: 'canViewPaymentHistoryReport',
    reqType: ['staff'],
    reqRole: ['company_admin', 'teamlead', 'agent', 'office_manager'],
    reqCode: 'deal_management',
  },
  {
    name: 'canViewGoalPacingReport',
    reqType: ['staff'],
    reqRole: ['company_admin', 'teamlead', 'agent', 'office_manager'],
    reqCode: 'deal_management',
  },
  {
    name: 'canViewLeadSourceReport',
    reqType: ['staff'],
    reqRole: ['company_admin', 'teamlead', 'agent', 'office_manager'],
    reqCode: 'deal_management',
  },
  {
    name: 'canViewAgentRoleReport',
    reqType: ['staff'],
    reqRole: ['company_admin', 'teamlead', 'agent', 'office_manager'],
    reqCode: 'deal_management',
  },
  {
    name: 'canViewCompanyLeaderboardReport',
    reqType: ['staff'],
    reqRole: ['company_admin', 'teamlead', 'agent', 'office_manager'],
    reqCode: 'deal_management',
  },
  {
    name: 'canFilterReportsByState',
    reqType: ['staff'],
    reqRole: ['company_admin', 'office_manager'],
    reqCode: null,
  },
  {
    name: 'canViewMyTeamRankingsReport',
    reqType: ['staff'],
    reqRole: ['company_admin', 'teamlead', 'office_manager'],
    reqCode: 'deal_management',
  },
  {
    name: 'canViewDealSummary',
    reqType: ['staff'],
    reqRole: ['company_admin', 'teamlead', 'agent', 'office_manager'],
    reqCode: 'deal_management',
  },
  {
    name: 'canViewMyTasks',
    reqType: ['staff'],
    reqRole: ['company_admin', 'teamlead', 'agent', 'office_manager'],
    reqCode: 'deal_management',
  },
  {
    name: 'canViewCompanyReportsHub',
    reqType: ['staff'],
    reqRole: [],
    reqCode: null,
  },
] as const;

export type CapabilityName = typeof CAPABILITY_RULES[number]['name'];
